// extracted by mini-css-extract-plugin
module.exports = {"header":"LiftingHeader_header__3YEwh","lifterName":"LiftingHeader_lifterName__2Vzfo","info":"LiftingHeader_info__3mt5G"};